/*** IMPORTS FROM imports-loader ***/
var define = false;

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

